export enum ContactRole {
    Buyer = 'buyer',
    Approver = 'approver',
    Admin = 'admin',
    Requester = 'requester',
}